import React from 'react';

import DownloadApp from 'apps/auth/components/common/DownloadApp';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

type ExtraLinks = {
    googleLink?: string;
    appleLink?: string;
    huaweiLink?: string;
};

type DownloadPageMessages = {
    downloadPageTitle?: string;
    downloadPageInfo?: string;
};

const ProfileDownloadPage = () => {
    const extraLinks = useExtra<ExtraLinks>();
    const pageMessages = usePageMessages<DownloadPageMessages>();

    return (
        <CommonPage backUrl={AUTH_PROFILE} leftCloseIcon>
            <HeaderPanel title={pageMessages?.downloadPageTitle} isCentered />
            <DownloadApp
                info={pageMessages?.downloadPageInfo}
                googlePlayLink={extraLinks?.googleLink}
                appleStoreLink={extraLinks?.appleLink}
                huaweiGalleryLink={extraLinks?.huaweiLink}
            />
        </CommonPage>
    );
};

export default BasePage(ProfileDownloadPage);
